export default __webpack_public_path__ + "media/zurb/img/case-study-cartpros/cartpros-img4-7c3d01823e81f141d8008daee5ea7a87.jpg";